module.exports = __webpack_public_path__ + "static/media/Deansgate.e0b86020.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/font/Deansgate.ttf
// module id = 26
// module chunks = 0